import { render, staticRenderFns } from "./editPaxelMarketSOP.vue?vue&type=template&id=63da7621&"
import script from "./editPaxelMarketSOP.vue?vue&type=script&lang=js&"
export * from "./editPaxelMarketSOP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports